import DataLakeWidgetConfig from "data-lake/logic/DataLakeWidgetConfig";
export const INITIAL_PAGE = 1;
export const PAGE_SIZE = 100;
export const MAX_LOADED_MESSAGES = 500;
export const MAX_PAGE = MAX_LOADED_MESSAGES / PAGE_SIZE;
export const PREVIEW_JOB_STATUS = {
  done: "DONE",
  running: "RUNNING",
  expired: "EXPIRED",
  error: "ERROR",
  timeout: "TIMEOUT",
  reset: "RESET",
  cancelled: "CANCELLED"
};
export const WIDGET_DEFAULTS = {
  id: "data-lake-widget-id",
  fields: DataLakeWidgetConfig.defaultFields,
  sort: DataLakeWidgetConfig.defaultSortDirection,
  tieBreaker: "timestamp",
  fieldFilters: [],
  fieldsOperator: "AND",
  size: PAGE_SIZE,
  timerange: { type: "relative", from: 1800 }
};
export const VALID_INITIAL_SEARCH_STATUSES = [
  PREVIEW_JOB_STATUS.done,
  PREVIEW_JOB_STATUS.running,
  PREVIEW_JOB_STATUS.timeout,
  PREVIEW_JOB_STATUS.error
];
export const HIDE_DL_SEARCH_EXPIRED_RESULT_ALERT = "hide-dl-search-expired-result-alert";
export const HIDE_DL_SEARCH_SUCCESSFUL_SEARCH_ALERT = "hide-dl-search-successful-search-alert";
export const DATA_LAKE_PREVIEW_QUERY_KEY = "data-lake-preview";
export const INTERNAL_DATA_LAKE_QUERY_TYPE = "data_lake_iceberg";
export const EXTERNAL_DATA_LAKE_QUERY_TYPE = "data_lake_external_data_lake";
export const INTERNAL_DATA_LAKE_SEARCH_TYPE = "iceberg-rows";
export const EXTERNAL_DATA_LAKE_SEARCH_TYPE = "external-data-lake-rows";
export const MINIMAL_FIELDS_INITIAL_WIDGET_CONFIG = 4;
export const VALID_ACTIVE_SEARCH_STATUSES = [
  ...VALID_INITIAL_SEARCH_STATUSES,
  PREVIEW_JOB_STATUS.expired
];
